
export enum ProjectMemberType{
    project = "project",
    trigger = "trigger",
    action = "action",
    shellData = "shellData",
    javaData = "javaData",
    triggerAction = "triggerAction",
    actionGroup = "actionGroup",
    triggerGroup = "triggerGroup",
    triggerActionGroup = "triggerActionGroup",
    checks = "GroupCheckList1",
    
}